'use client';

import { useEffect } from 'react';

import { applyRootStyles, cleanupRootStyles } from '../utils';
import { usePrevious } from './usePrevios';

export const useModalEffect = (isOpen: boolean) => {
  const prevOpen = usePrevious(isOpen);

  // Automatically apply the iOS modal effect to the body when sheet opens/closes
  useEffect(() => {
    if (!prevOpen && isOpen) {
      applyRootStyles();
    } else if (!isOpen && prevOpen) {
      cleanupRootStyles();
    }
  }, [isOpen, prevOpen]);  

  // Make sure to cleanup modal styles on unmount
  useEffect(() => {
    return () => {
      if (isOpen) cleanupRootStyles();
    };
  }, [isOpen]);  
};
